export const TOOL_TASK = 'set-user-state';
export const TOOL_TITLE = 'Set User State';
export const TOOL_PROGRESS_LABEL = 'Bulk user state updating progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating user state finishes';
export const FILE_NAME = 'Set-user-state-report';
export const FILE_HEADERS = {
    userId: 'User Id',
    userEmail: 'Email',
    oldType: 'Old Type',
    oldStatus: 'Old Status',
    newType: 'New Type',
    newStatus: 'New Status',
    actionStatus: 'Action Status',
};

export const MODAL_WIDTH = 400;
